import { RouteComponentProps } from '@reach/router';
import ResetPasswordForm from 'components/resetPasswordForm/ResetPasswordForm';
import React from 'react';
import Page from '../components/shared/Page';

export const ResetPassword: React.FC<RouteComponentProps> = () => {
  return (
    <Page isPublic autoLogin={false}>
      <div className="ResetPasswordPage">
        <div className="Content HeightContent">
          <ResetPasswordForm />
        </div>
      </div>
    </Page>
  );
};
